import { CallableInput } from "Components/Shared";
import FormSubmit from "Components/Shared/FormSubmit";
import { FastField, Formik } from "formik";
import { useRole } from "Hooks/Endpoints";
import React from "react";
import { Container, Form, Header } from "semantic-ui-react";

const RoleCreate = () => {
  const { createRole, saveRole, validateRoleName, uncreateRole } = useRole();
  return (
    <Container>
      <Header as='h3'>Create Role</Header>
      <br />
      <Formik
        validateOnChange={true}
        initialValues={createRole}
        onSubmit={(values, actions) => {
          saveRole(values);
        }}
      >
        {({ handleSubmit, setFieldValue, errors, validateField }) => (
          <Form onSubmit={handleSubmit}>
            <FastField
              name='name'
              label='Name'
              validate={validateRoleName}
              component={CallableInput}
            />

            <FastField
              name='description'
              label='Description'
              component={CallableInput}
            />

            <FormSubmit
              name='Create Role'
              errors={errors}
              onCancel={uncreateRole}
            />
          </Form>
        )}
      </Formik>
    </Container>
  );
};

export default RoleCreate;
